export const CLICK_REMIND_ME = {
    url: '/trk/livestream:click_remind_me',
    isUserEngagement: true,
    consent: 'essential',
};
export const CONFIRM_REMIND_ME = {
    url: '/trk/livestream:confirm_remind_me',
    isUserEngagement: true,
    consent: 'essential',
};
export const SEND_CHAT = {
    url: '/trk/livestream:send_chat',
    isUserEngagement: true,
    consent: 'essential',
};
export const SEND_CHAT_PRIVATE = {
    url: '/trk/livestream:send_chat_private',
    isUserEngagement: true,
    consent: 'essential',
};
export const SEND_HEART = {
    url: '/trk/livestream:click_heart',
    isUserEngagement: true,
    consent: 'essential',
};
export const SELECT_TARGET_CALENDAR = {
    url: '/trk/livestream:select_target_calendar',
    isUserEngagement: true,
    consent: 'essential',
};
export const START_ACTIVE_WATCH = {
    url: '/trk/livestream:start_active_watch',
    isUserEngagement: true,
    consent: 'essential',
};
export const TRACK_CLICK_PRODUCT_MOMENT = {
    url: '/trk/livestream:click_product_moment',
    isUserEngagement: true,
    consent: 'essential',
};
// https://fwn.atlassian.net/browse/CS-1184
export const SEND_CONNECT = {
    url: '/trk/ls_test:connect',
    isUserEngagement: false,
    consent: 'essential',
};
/**
 * Note: Adding an endpoint to this file requires update to
 * the Jira docs https://fwn.atlassian.net/wiki/x/SQAELQ
 */
